<template>
  <div class="root-container">
    <top-menu
      ref="top-menu"
      @search="changeDate"
      @logout="$emit('logout')"
    />
    <v-toolbar
      height="64px"
      :elevation="4"
      color="transparent"
    >
      <v-container
        fluid
      >
        <v-row>
          <v-col md="12">
            <v-toolbar-items>
              <v-btn
                :to="{ path: '/shifts/edit', query: { date: $route.query.date } }"
                size="large"
                class="shift-edit-btn edit-btn pr-8 pl-8"
              >
                編集する
                <v-icon
                  icon="mdi-border-color mt-1"
                  size="large"
                />
              </v-btn>
              <div
                v-if="shiftsUpdateSkippings.length > 0"
                style="padding-left:20px"
                class="blue--text"
              >
                <div v-for="skippingInfo in shiftsUpdateSkippings">
                  {{ skippingInfo }}
                </div>
              </div>
            </v-toolbar-items>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>
    <v-container
      fluid
      class="table-container px-0 py-0"
    >
      <shift-table :shifts="shifts">
        <template #cell="{ shift }">
          {{ findDoctorName(shift.doctor_id) }}
        </template>
      </shift-table>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TopMenu from "./shared/TopMenu.vue";
import ShiftTable from "./shared/ShiftTable.vue";

export default {
  name: "Shift",
  components: {
    TopMenu,
    ShiftTable
  },
  emits: ["logout"],
  computed: {
    ...mapGetters(["shifts", "doctors", "shiftsUpdateSkippings"]),
  },
  watch: {
    "$route" () {
      this.$store.dispatch("fetchShiftsOfDay", {
        date: this.$route.query.date
      });
    }
  },
  created() {
    this.$store.dispatch("fetchDoctors").then(()=>{
      this.$store.dispatch("fetchShiftsOfDay", {
        date: this.$route.query.date
      });
    });
  },
  methods: {
    changeDate(d) {
      this.$router.push({ name: "shift", query: { date: d } });
    },
    findDoctorName(doctor_id) {
      let index = this.doctors.findIndex((v) => v.id === doctor_id);
      if(index == -1) {
        return "";
      }
      return this.doctors[index]["name"];
    }
  }
};
</script>
<style lang="scss">
.shift-edit-btn.edit-btn {
  font-size: 15px !important;
  text-decoration: none !important;
  background-color: #ec407a !important;
  border-color: #ec407a !important;
  color: black !important;
}
</style>

<style scoped>
.root-container {
  height: 100vh;
  display: flex;
  flex-direction:column;
}

.table-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
</style>
